module.exports = __webpack_public_path__ + "static/media/microscope-line.4462e6fd.svg";